import * as React from 'react';
import {
  useAutocomplete,
  AutocompleteGetTagProps,
} from '@mui/base/AutocompleteUnstyled';
import { Autocomplete, TextField, useMediaQuery } from '@mui/material';
import { useChallengeContextContext } from 'context/ChallengeContext/ChallengeContext';
import { EditorProps } from 'react-data-grid';
// import { InputWrapper, Label, Listbox, Root, StyledTag } from './style';

// interface IProps {}

export function WorkoutIdsAutoCompleteComponent<
  TRow extends IChallengeRoutines,
  TSummaryRow,
>({ row, column, onRowChange, onClose }: EditorProps<TRow, TSummaryRow>) {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const { workoutsAutoComplete } = useChallengeContextContext();
  // const {
  //   getRootProps,
  //   getInputLabelProps,
  //   getInputProps,
  //   getTagProps,
  //   getListboxProps,
  //   getOptionProps,
  //   groupedOptions,
  //   value,
  //   focused,
  //   setAnchorEl,
  // } = useAutocomplete({
  //   id: 'customized-hook-demo',
  //   multiple: true,
  //   options: [...new Set(workoutsAutoComplete)],
  //   getOptionLabel: (option) => option.name,
  //   // groupBy: (option) => option.part.name,
  // });

  const onChangeValue = (value: Workout[]) => {
    onRowChange(
      {
        ...row,
        workout_ids_array: value,
      },
      true,
    );
    // onClose();
  };

  return (
    <Autocomplete
      multiple
      size='small'
      autoSelect
      autoHighlight
      value={row.workout_ids_array || []}
      getOptionLabel={(option) => option.name}
      groupBy={(option) => option.part.name}
      sx={{ width: '100%', flex: 1 }}
      options={[...new Set(workoutsAutoComplete)]}
      onChange={(_, value) => onChangeValue(value)}
      renderInput={(params) => (
        <TextField
          sx={{ input: { color: prefersDarkMode ? 'white' : 'black' } }}
          autoFocus
          {...params}
          size='small'
          type='text'
          placeholder='운동명'
        />
      )}
    />
  );
}
